import ProgressBar from './progress-bar.vue';

export default {
  data() {
    return {
      displayed: false,
      page: 0,
      sortBy: 'last_name',
      sortDir: 'DESC',
      lastLoadedPage: 0,
      amountPerPage: 10,
      sessionCount: 0,
      studentCount: 0,
      courseID: null,
      courseworkCount: 0,
      students: null,
      showCertificatesCol: Kadenze.isKadenze,
      sortingParams: {
        student: 'last_name',
        session: 'sessions_completed',
        coursework: 'completed_coursework',
        certificate: 'certificate_issued',
        course_last_accessed: 'last_accessed',
      },
      sortingParamsMapping: {
        last_name: 'student',
        sessions_completed: 'session',
        completed_coursework: 'coursework',
        certificate_issued: 'certificate',
        last_accessed: 'course_last_accessed',
      },
      filter: '',
      searchEnabled: false,
      filterQueueLength: 0,
      lastFilterID: null,
    };
  },
  components: {
    ProgressBar
  },
  computed: {
    index() {
      return this.page * this.amountPerPage;
    },
    order() {
      return {
        col: this.sortBy,
        dir: this.sortDir
      };
    },
    tableStudents() {
      if ( this.students ) {
        return this.students.slice(this.index, this.index + this.amountPerPage);
      }
    },
    paginationText() {
      if ( this.students ) {
        return `${this.index}-${this.index + Math.min(this.amountPerPage, this.studentCount)} of ${this.studentCount}`;
      }
    },
    lastPage() {
      return this.page == this.pageCount - 1;
    },
    pageCount() {
      if ( this.students ) {
        return Math.ceil(this.studentCount / this.amountPerPage);
      } else {
        return 0;
      }
    },
    columnActiveClass() {
      const classObj = {};
      classObj[this.sortingParamsMapping[this.sortBy]] = ['student-engagement__sort-active'];
      return classObj;
    },
    columnArrowClass() {
      const classObj = {};
      classObj[this.sortingParamsMapping[this.sortBy]] = [`student-engagement__${this.sortDir == 'ASC' ? 'down' : 'up'}-arrow`];
      return classObj;
    },
  },
  watch: {
    amountPerPage() {
      this.amountPerPage = parseInt(this.amountPerPage);
      this.getStudents(0, this.amountPerPage, true).then(() => this.page = 0);
    },
    displayed() {
      if ( this.displayed )  {
        $('.js-range-picker').hide();
      } else (
        $('.js-range-picker').show()
      );
    },
    filter() {
      if ( this.filter.length != 1 ) {
        this.debouncedFilter();
      }
    },
    searchEnabled() {
      if ( this.searchEnabled ) {
        TweenLite.to($('.student-engagement__search-items i, .student-engagement__inline-loader'), 0.5, { x: 0, ease: Power2.easeInOut });
        TweenLite.to($('.student-engagement__search-items input'), 0.3, { delay: 0.3, opacity: 1, ease: Power2.easeInOut });
      } else {
        TweenLite.to($('.student-engagement__search-items i, .student-engagement__inline-loader'), 0.5, { delay: 0.3, x: 168, ease: Power2.easeInOut });
        TweenLite.to($('.student-engagement__search-items input'), 0.3, { opacity: 0, ease: Power2.easeInOut});
      }
    }
  },
  methods: {
    bindData(data) {
      this.students = data.students;
      this.courseworkCount = data.coursework_count;
      this.sessionCount = data.session_count;
      this.studentCount = data.student_count;
      this.courseID = data.course_id;
    },
    courseworkProgress(student) {
      return `${this.$options.filters.numberToPercentage(student.progress.coursework_progress, 2, false)} (${student.progress.completed_coursework} / ${this.courseworkCount})`;
    },
    sessionProgress(student) {
      return `${this.$options.filters.numberToPercentage(student.progress.session_progress, 2, false)} (${student.progress.sessions_completed}/${this.sessionCount})`;
    },
    certificateIssued(student) {
      if ( student.progress.certificate_issued ) {
        return moment(student.progress.certificate_issued).format(Kadenze.I18n.t('date.formats.js_default_without_zone'));
      }
    },
    setSort(type) {
      if(this.sortBy == this.sortingParams[type]) {
        this.sortDir = (this.sortDir == 'ASC') ? 'DESC' : 'ASC';
      } else {
        this.sortBy = this.sortingParams[type];
        this.sortDir = 'DESC';
      }

      this.getStudents(0, this.amountPerPage, true).then(() => this.page = 0);
    },
    getStudents(page, per, clear = false, showLoader = true) {
      const params = {
        url: Kadenze.Routes.course_analytics_path(this.courseID, { page, per, order: this.order, q: this.filter }),
        headers: {'Access-Control-Allow-Origin':'*'},
        dataType: 'json',
        type: 'GET',
      };

      if(showLoader) {
        params['loadingIndicator'] = {
          container: $('.student-engagement__table')
        };
      }

      return new Kadenze.AjaxRequest(params).success((resp) => {
        const data = JSON.parse(resp.data);
        if ( clear ) {
          this.students = [];
          this.lastLoadedPage = 0;
        }
        data.students.forEach((s) => this.students.push(s));
        this.studentCount = data.student_count;
      }).error((resp) => {
        console.warn(resp);
      });
    },
    nextPage() {
      if ( this.page == this.lastLoadedPage ) {
        this.getStudents(this.page + 2, this.amountPerPage).then(() => {
          this.page += 1;
          this.lastLoadedPage = this.page;
        });
      } else {
        this.page += 1;
      }
    },
    download() {
      new Kadenze.AjaxRequest({    
        url: Kadenze.Routes.student_engagement_download_path(this.courseID),
        dataType: 'json',
        contentType: 'application/json',
        headers: {'Access-Control-Allow-Origin':'*'},
        type: 'GET'
      }).success((data) => {
        var encodedUri = 'data:application/csv;charset=utf-8,' + encodeURIComponent(data.status);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "student_engagement.csv");
        link.innerHTML= "Download do Relatório";
        document.body.appendChild(link);
        link.click();
        new Kadenze.Notice.success({
          message: Kadenze.I18n.t('course.analytics.student_engagement_download')
        });
      }).error((resp) => {
        console.warn(resp);
      });
    },
    toggleSearch() {
      if ( (this.filterQueueLength == 0 || this.filter == '')) {
        this.searchEnabled = !this.searchEnabled;
      }
    },
    updateFilter() {
      this.filterQueueLength += 1;
      this.getStudents(0, this.amountPerPage, true, false).then(() => {
        this.page = 0;
        this.filterQueueLength -= 1;
        if ( this.filterQueueLength < 0 ) {
          this.filterQueueLength = 0;
        }
      });
    },
    onInputBlur() {
      if (this.filter === '') {
        this.searchEnabled = false;
      }
    }
  },
  created() {
    this.debouncedFilter = _.debounce(this.updateFilter, 200);
  },
  mounted() {
    // Hack to keep track of when Vue vm is displayed by KO
    setTimeout(() => {
      const parentVM = ko.contextFor($('#js-course-analytics-view')[0]);
      if ( parentVM.$root && parentVM.$root.currentView ) {
        parentVM.$root.currentView.subscribe((view) => {
          this.displayed = ( view == 'student' );
        });
      }
    }, 100);
  }
};
